module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "match__dice",
    attrs: {
      "id": _vm.id
    }
  }, [_c('vue-audio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.id === 'userDiceS' || _vm.id === 'pcDiceS'),
      expression: "id === 'userDiceS' || id === 'pcDiceS'"
    }],
    ref: "dice",
    attrs: {
      "file": 7,
      "loop": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59cb7d9f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dice.vue
// module id = 81
// module chunks = 0